// API configuration
// Automatically detect environment and set appropriate API_BASE_URL
export const API_BASE_URL = (() => {
  // Check if we're in development mode (localhost)
  if (typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || 
       window.location.hostname === '127.0.0.1' || 
       window.location.hostname.includes('localhost'))) {
    return "https://silulumanzi.local/portal";
  }
  // Production environment
  return "/portal";
})();

// Socket.IO server configuration
export const SOCKET_URL = (() => {
  // Check if we're in development mode (localhost)
  if (typeof window !== 'undefined' && 
      (window.location.hostname === 'localhost' || 
       window.location.hostname === '127.0.0.1' || 
       window.location.hostname.includes('localhost'))) {
    return "http://localhost:3002"; // Local development socket server
  }
  // Production environment
  return "https://webhook.silulumanzi.com:90";
})();

export const base_url = "https://portal.silulumanzi.com/portal"; 
export const statement = "https://portal.silulumanzi.com/statement";

// Environment detection utilities
export const isLocalDevelopment = () => {
  return typeof window !== 'undefined' && 
         (window.location.hostname === 'localhost' || 
          window.location.hostname === '127.0.0.1' || 
          window.location.hostname.includes('quality')||
          window.location.hostname.includes('quality.silulumanzi.com')||
        window.location.hostname.includes('localhost'));
};

export const getEnvironment = () => {
  return isLocalDevelopment() ? 'development' : 'production';
};

// CUSTOMER PORTAL API CONFIGURATION
// Toggle this to switch between local development and remote testing
export const CUSTOMER_PORTAL_CONFIG = {
  // Set to 'development' for local API or 'testing' for remote API
  // Check localStorage first, then fallback to default
  mode: (() => {
    if (typeof window !== 'undefined') {
      const savedMode = localStorage.getItem('customerPortalApiMode');
      if (savedMode && (savedMode === 'development' || savedMode === 'testing')) {
        return savedMode;
      }
    }
    return 'testing'; // Default to testing mode
  })(),
  
  development: {
    baseUrl: 'http://silulumanzi.host/portal',
    externalApiUrl: '/api/external1'
  },
  
  testing: {
    baseUrl: 'https://quality.silulumanzi.com',
    externalApiUrl: '/api/external'
  }
};

export const getCustomerPortalApi = () => { 
  return {
    baseUrl: base_url,
    externalApiUrl: '/api/external',
    fullApiUrl: `${base_url}'/api/external'`
  };
};

// Utility function to switch API mode
export const switchCustomerPortalApiMode = (newMode) => {
  if (newMode === 'development' || newMode === 'testing') {
    CUSTOMER_PORTAL_CONFIG.mode = newMode;
    if (typeof window !== 'undefined') {
      localStorage.setItem('customerPortalApiMode', newMode);
    }
    return true;
  }
  return false;
};

// App configuration
export const APP_NAME = 'Portal';
export const APP_VERSION = '1.0.0';

// Feature flags
export const FEATURES = {
  enableAzureLogin: true,
  enableOTP: true,
};
 